export default {
  list: {
    name: "wechat red packet topup list api",
    version: 6,
    url: "wechat/red-packet-topups",
    method: "GET",
  },
};
